// extracted by mini-css-extract-plugin
module.exports = {"root":"_833a1c7ed67985e6bdcdf9da51e3e735"};